/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{flex:1}.save-button-container[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{width:92%}.message-container[_ngcontent-%COMP%]{font-size:18px}.margin-sides[_ngcontent-%COMP%]{margin-left:20px;margin-right:20px}"];
export { styles as styles };
